module.exports = __webpack_public_path__ + "static/media/blockchainNews.c98786fb.png";